export const getSourceRealEstateId = () => new URLSearchParams(window.location.search).get('sourceRealEstateId')

export const hasListingTypeChangeCopyContext = () => {
  const searchParams = new URLSearchParams(window.location.search)

  return searchParams.get('entryMode') === 'LISTING_TYPE_CHANGE_COPY' && Boolean(getSourceRealEstateId())
}
